import { createApp, h, type DefineComponent } from 'vue';
import { createI18n } from 'vue-i18n';
import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import axios from 'axios';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import 'primeicons/primeicons.css';
import { ZiggyVue } from 'ziggy-js';
//import type { SharedProps } from "./Types/inertia";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

import { NoirSample } from '@/Themes/noir-sample';
import PrimeVue from 'primevue/config';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';

import './echo';
// for sanctum
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

const appName = import.meta.env.VITE_APP_NAME || 'Nihongo Ninja';

/* import the fontawesome core */

import './icons';

import ar from '@/lang/ar.json';
import de from '@/lang/de.json';
import en from '@/lang/en.json';
import es from '@/lang/es.json';
import fr from '@/lang/fr.json';
import nl from '@/lang/nl.json';

const i18n = createI18n({
    legacy: false,
    locale: 'en', // Default, will be overridden
    fallbackLocale: 'en',
    messages: {
        ar: ar as Record<string, string>,
        de: de as Record<string, string>,
        en: en as Record<string, string>,
        es: es as Record<string, string>,
        fr: fr as Record<string, string>,
        nl: nl as Record<string, string>,
    } as Record<string, Record<string, string>>, // ✅ Allow dynamic messages
});

/* import font awesome icon component */

// https://github.com/laravel/vite-plugin/issues/177 for the <DefineComponent>
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob<DefineComponent>('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        axios.get('/sanctum/csrf-cookie').then(() => {
            // not setting return as in JS here removes error
            const app = createApp({ render: () => h(App, props) });
            app.use(pinia);
            app.use(plugin);
            app.use(ZiggyVue);
            app.use(i18n);

            app.use(PrimeVue, {
                theme: {
                    preset: NoirSample, // Use the theme from store
                    options: {
                        darkModeSelector: '.my-app-dark',
                    },
                },
                cssLayer: {
                    name: 'primevue',
                    order: 'tailwind-base, primevue, tailwind-utilities',
                },
            });
            app.use(ToastService);
            app.component('Toast', Toast);

            //app.use(i18n);

            /*
            app.mixin({
                mounted() {
                    const page = usePage<SharedProps>();
                    i18n.global.locale = page.props.locale;
                    i18n.global.mergeLocaleMessage(
                        page.props.locale,
                        page.props.translations as Record<string, string>,
                    );
                },
            });

             */

            app.mount(el);
        });
    },
    progress: {
        color: '#4B5563',
    },
}).then(() => {
    //console.log(response);
});
